<template>
  <div class="public-services">
    <md-dialog-alert
      v-if="linkDisabled"
      :md-active.sync="linkDisabled"
      :md-content="
        $t(linkExpired ? 'public.services_expired' : 'public.services_disabled')
      "
      md-confirm-text="Ok"
    ></md-dialog-alert>
    <public-history-dialog
      :items="selectedHistory"
      :service="selectedService"
      :active.sync="showHistory"
      @open-link="openLink"
      @check-service="checkServiceLink"
    ></public-history-dialog>
    <md-card class="md-card-unspaced public-services-card rfider-shadow">
      <md-card-content>
        <md-subheader class="public-service-card-header">
          {{ $t('public.services_title') }}
          <md-button
            v-if="history && history.length"
            class="md-simple md-just-icon btn-history"
            @click="openHistoryDialog(-1, true)"
          >
            <md-icon>history</md-icon>
          </md-button>
        </md-subheader>
        <div
          v-for="(service, index) in items"
          :key="index"
          class="md-layout md-alignment-center-center public-service-card-list"
        >
          <div
            v-if="service.icon"
            class="md-layout-item md-layout-item--no-grow public-service-card-image"
          >
            <div><img :src="mixinGetFilePath(service.icon, 'O')" /></div>
          </div>
          <div class="md-layout-item">
            <a
              href
              @click.prevent="
                getHistory(service).length
                  ? openHistoryDialog(index, true)
                  : checkServiceLink(service)
              "
              class="public-service-card-link public-service-card-title"
            >
              {{ service.name }}
              <md-icon
                v-if="getHistory(service).length"
                class="public-service-card-icon-check"
                >check_circle_outline</md-icon
              >
              <md-icon class="public-service-card-icon">chevron_right</md-icon>
            </a>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import JwtDecode from 'jwt-decode';
import { mapGetters } from 'vuex';
import { getUrlParams } from '@/utils';
import store from '@/store';
import PublicHistoryDialog from '@/components/public/publicHistoryDialog.vue';

export default {
  components: {
    PublicHistoryDialog,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    history: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      linkExpired: false,
      linkDisabled: false,
      showHistory: false,
      selectedService: {},
      selectedHistory: [],
    };
  },
  computed: {
    ...mapGetters({
      gdprAccepted: 'core/gdprAccepted',
    }),
  },
  methods: {
    checkServiceLink(service) {
      if (!this.gdprAccepted) {
        store.commit('core/SET_GDPR_PROMPT', true);
        return;
      }

      const uri = service.url;
      var stop = true;
      this.linkDisabled = false;
      this.linkExpired = false;

      if (uri) {
        try {
          var decoded = JwtDecode(getUrlParams(uri).token);
          if (decoded.exp - Math.floor(Date.now() / 1000) > 30) {
            // if expring in more than 30 seconds
            stop = false;
          }
        } catch (err) {
          console.log(err);
        }
      }
      if (stop) {
        this.linkDisabled = true;
        if (uri) {
          this.linkExpired = true;
        }
        return;
      }

      this.openLink(service.url);
    },
    getHistory(service) {
      let matchedHistory = [];
      if (this.history && this.history.length) {
        matchedHistory = this.history.filter(
          (h) => String(h.taskId) === String(service.taskId),
        );
      }
      return matchedHistory;
    },
    openLink(uri) {
      window.open(uri, '_blank');
    },
    openHistoryDialog(index, addRoute) {
      if (addRoute) {
        this.$router.push({ query: { history: index } });
        return;
      }
      let service =
        index < 0 || !this.items[Number(index)]
          ? null
          : this.items[Number(index)];
      this.selectedService = service || null;
      this.selectedHistory = (
        service ? this.getHistory(service) : this.history
      ).map((h) => {
        const found = (this.items || []).find((s) => s.taskId === h.taskId);
        const icon = found ? found.icon : null;
        return {
          ...h,
          icon: icon,
        };
      });
      this.selectedHistory.sort((a, b) => b.createdAt - a.createdAt);
      this.showHistory = true;
    },
  },
  watch: {
    showHistory(newVal) {
      if (!newVal) {
        this.$router.push({ query: null });
      }
    },
    '$route.query': {
      immediate: true,
      handler(newVal) {
        if (typeof newVal.history !== 'undefined') {
          this.openHistoryDialog(newVal.history);
        } else {
          this.showHistory = false;
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/public/_public-services.scss';
</style>
